import { render, staticRenderFns } from "./PagePlaceholder.vue?vue&type=template&id=7171de83&scoped=true&"
import script from "./PagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./PagePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7171de83",
  null
  
)

export default component.exports